import { render, staticRenderFns } from "./fpTicket.vue?vue&type=template&id=6f65dff2&scoped=true&"
import script from "./fpTicket.vue?vue&type=script&lang=js&"
export * from "./fpTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f65dff2",
  null
  
)

export default component.exports